import { useLayoutEffect, useState } from "react";

let PolyfilledResizeObserver;
(async () => {
  if (typeof window !== "undefined" && window.ResizeObserver) {
    PolyfilledResizeObserver = window.ResizeObserver;
  } else {
    PolyfilledResizeObserver = (await import("resize-observer-polyfill"))
      .default;
  }
})();

export function useBoundingRect(ref) {
  const [boundingRect, setBoundingRect] = useState(null);
  
  useLayoutEffect(() => {
    // Guard clause: verificar que estamos en el cliente y que ref.current existe
    if (typeof window === "undefined" || !ref.current) {
      return;
    }

    // Guard clause: verificar que el elemento tiene un parentElement
    if (!ref.current.parentElement) {
      return;
    }

    // Inicializar con el bounding rect actual
    const initialRect = ref.current.getBoundingClientRect();
    setBoundingRect(initialRect);

    let awaitingAnimation = false;
    let observer = null;

    const useBoundingRectResizeListener = () => {
      if (!awaitingAnimation && ref.current) {
        awaitingAnimation = true;
        requestAnimationFrame(() => {
          if (ref.current) {
            setBoundingRect(ref.current.getBoundingClientRect());
          }
          awaitingAnimation = false;
        });
      }
    };

    // Inicializar observer cuando PolyfilledResizeObserver esté disponible
    const initObserver = async () => {
      if (!PolyfilledResizeObserver) {
        // Esperar a que el polyfill se cargue
        await new Promise((resolve) => {
          const checkInterval = setInterval(() => {
            if (PolyfilledResizeObserver) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 10);
        });
      }

      if (ref.current && ref.current.parentElement && PolyfilledResizeObserver) {
        observer = new PolyfilledResizeObserver(useBoundingRectResizeListener);
        observer.observe(ref.current.parentElement);
      }
    };

    initObserver();

    // Cleanup function
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [ref]);

  // Retornar null en SSR o si no hay datos, en lugar de undefined
  return boundingRect;
}
